'use strict';

/**
 * sgCheckImage Directive
 * 
 * Using this to check if (by using ngSrc) the image is loaded correctly. 
 * The gravatar should either show th
 */
(function () {	
  angular.module('specsguardApp')
    .directive('sgGravatarImage', sgGravatarImage);

  function sgGravatarImage () {
    return {
      link: function ($scope, element) {
        // When element fails to load imag
        element.on('error', function () {
          element.remove();
        });
      }
    };
  }
})();
